import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const Eye: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 22, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 15) / 22}
      viewBox="0 0 22 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.2891 6.75405C19.7634 4.72405 15.6846 0 10.7672 0C5.84987 0 1.77097 4.72401 0.247438 6.75405C-0.0824794 7.19322 -0.0824794 7.80683 0.247438 8.24608C1.77097 10.2781 5.84983 15 10.7672 15C15.6845 15 19.7634 10.2781 21.289 8.24608C21.619 7.80678 21.619 7.19322 21.2891 6.75405ZM10.7672 12.3984C8.06689 12.3984 5.86879 10.2003 5.86879 7.5C5.86879 4.79966 8.06689 2.60371 10.7672 2.60371C13.4676 2.60371 15.6656 4.79966 15.6656 7.5C15.6656 10.2003 13.4675 12.3984 10.7672 12.3984Z"
        fill="currentColor"
      />
      <path
        d="M13.9486 7.49972C13.9486 9.25443 12.5217 10.6834 10.767 10.6834C9.01235 10.6834 7.58545 9.25443 7.58545 7.49972C7.58545 5.74501 9.01235 4.31812 10.767 4.31812C12.5217 4.31812 13.9486 5.74501 13.9486 7.49972Z"
        fill="currentColor"
      />
    </svg>
  )
})

Eye.displayName = 'Eye'
